import React, { useState, useEffect , useRef  } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { color } from 'framer-motion';
import { FiTrash2, FiDownload, FiFileText } from 'react-icons/fi';

const Container = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
`;

const MainBox = styled.div`
display:flex;
  flex-direction:column;
  align-items:center;
  justify-content: center;
  margin: 100px;
  text-align:center;

 @media (max-width: 480px) {
    margin: 50px;
  }
`;

const Title = styled.div`
  font-size: 28px;
  color: #385963;
  font-weight: 600;
  margin-bottom: 10px;

   @media (max-width: 480px) {
     margin-bottom: 30px;
     font-size: 20px;
  }
`;

const InfoBox = styled.div`
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 30px;
  display: block;

   @media (max-width: 480px) {
     font-size: 16px;
    margin-bottom: 20px;
  }
`;

const FileInput = styled.input`
  margin: 10px 0 20px 0;
`;

const Button = styled.button`
  padding: 10px 20px;
  background-color: #385963;
  color: white;
  border: none;
  cursor: pointer;
  font-weight: bold;
  border-radius: 5px;

  &:hover {
    background-color: #2e4852;
  }
`;


const UpdateButton = styled.button`
  background-color: #4caf50;
  color: white;
  font-size: 18px;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #388e3c;
  }


  
`;

const FileList = styled.div`
  margin-top: 20px;
`;

const FileLink = styled.a`
  display: inline-block;
  margin-right: 15px;
  margin-bottom: 10px;
  text-decoration: underline;
  color: #385963;
  cursor: pointer;

  &:hover {
    color: #2e4852;
  }
`;

const SuccessMessage = styled.p`
  color: green;
  margin-top: 20px;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.75);
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  width: 90vw;
  height: 90vh;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
`;

const PdfIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;


const FieldGroup = styled.div`
     margin-bottom: 40px;
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 16px;

 @media (max-width: 480px) {
     font-size: 12px;
    margin-bottom: 20px;
  }

`;

const DeleteButton = styled.button`
  background-color: #ff4d4d;  /* Red background */
  color: white;
  border: none;
  padding: 0.5rem 1rem;  /* Smaller padding */
  font-size: 0.9rem;      /* Smaller font size */
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
  
  &:hover {
    background-color: #e60000;  /* Darker red on hover */
  }
`;

const FileListContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const FileCard = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  gap: 50px;
  background: #f8f9fa;
  padding: 12px 16px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  margin-bottom: 12px;

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  margin-right: 20px;

  svg {
    color: #385963;
    font-size: 20px;
  }

  span {
    font-weight: 500;
    color: #333;
    font-size: 16px;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

const FileActions = styled.div`
  display: flex;
  gap: 10px;

  button, a {
    display: flex;
    align-items: center;
    // gap: 5px;
    background: none;
    border: none;
    color: #385963;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 6px;
    text-decoration: none;
    transition: background-color 0.2s ease;

    svg {
      font-size: 18px;
    }

    &:hover {
      background-color: #d6e4e9;
      color: #2e4852;
    }
  }

  button.delete {
    color: #e74c3c;

    &:hover {
      background-color: #f9d6d5;
      color: #c0392b;
    }
  }

   @media (max-width: 768px) {
       gap: 10px;
        button, a {
          padding: 2px
        }
    }
`;


// FilePlaceTypeEnum
const FILE_PLACE_TYPE = {
  Gallery: 0,
  CategoryPhoto: 1,
  CoverPhoto: 2,
  Poster: 3,
  File: 4
};


const ProfileMenuPreApprovedProvider = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tokenString = sessionStorage.getItem('token');
  const { t, i18n } = useTranslation();
 
    const navigate = useNavigate();

//   const [existingFiles, setExistingFiles] = useState([]); 
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const filesInputRef = useRef(null);
  const decodedToken = jwtDecode(decodeURIComponent(tokenString));
  const userName = decodedToken.name;
  const email = decodedToken.unique_name;

  const [form, setForm] = useState({
    existingFiles:[],
    files: [],  
  });

const userId = decodedToken.sub;
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const openPreview = (url) => {
  if (pdfPreviewUrl) {
    URL.revokeObjectURL(pdfPreviewUrl); // Cleanup previous preview URL
  }

  if (isMobile) {
    window.open(url, '_blank');
  } else {
    setPdfPreviewUrl(url);
    setModalVisible(true);
  }
};

const closePreview = () => {
  if (pdfPreviewUrl) {
    URL.revokeObjectURL(pdfPreviewUrl); // Cleanup when closing preview
  }
  setModalVisible(false);
  setPdfPreviewUrl(null);
};


  const handleSubmit = async (e) => {
  e.preventDefault();
  try{
    // Prepare files and types for upload
    const uploadFileList = [];
    const fileTypes = [];

    if (form.files.length > 0) {
      uploadFileList.push(...form.files);
      fileTypes.push(...Array(form.files.length).fill(FILE_PLACE_TYPE.File));
    }

    if (uploadFileList.length > 0) {
      await uploadFiles(uploadFileList, fileTypes);
    }

    alert(t('fileAddedSuccessfully'));
    navigate('/profile-menu-pre-approved-provider');
  } catch (error) {
    console.error('Error :', error);
    alert(t('errorCreatingDestination') + ': ' + error.message);
  }
};


const uploadFiles = async ( files, types) => {
  const formData = new FormData();

  for (let i = 0; i < files.length; i++) {
    formData.append('uploadFiles', files[i]);
    formData.append('uploadFileTypes', types[i].toString());
  }

  try {
    const response = await fetch(`${BASE_URL}ProviderProfile/uploadFiles`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${tokenString}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
       alert(t('uploadFilesFailedPleaseEditAndTryAgain'));
      throw new Error(errorText);
       setUploadSuccess(false);
    }
    else{
      console.log('Upload success!');
      setUploadSuccess(true);
        
    }
        
  } catch (error) {
    console.error('Upload error:', error);
  }
};


  const handleCategoryChange = (value) => {
    setForm((prev) => ({
      ...prev,
      categoryId: value,
    }));
  };


  const handleFileChange = (e, isMultiple, field) => {
  const files = e.target.files;
  if (!files || files.length === 0) return;

  if (isMultiple) {
    setForm(prev => ({
      ...prev,
      files: [...prev.files, ...Array.from(files)],
    }));
  } else if (field) {
    setForm(prev => ({
      ...prev,
      [field]: files[0],
    }));
  }
};

const handleDeleteNewGalleryPhoto = (index) => {
  setForm(prev => ({
    ...prev,
    files: prev.files.filter((_, i) => i !== index),
  }));
    // Optional: reset input when all are removed
  if (form.files.length === 1 && filesInputRef.current) {
   filesInputRef.current.value = '';
  }
};


  return (
    <Container>
        <MainBox>
      <Title style={{marginBottom:'40px'}}>{t("completeProviderRegistration")}</Title>

      <InfoBox>
        <p><strong>{t("Name")}:</strong> {userName}</p>
        <p><strong>{t("Email")}:</strong> {email}</p>
      </InfoBox>

    <form onSubmit={handleSubmit}>
      <Title style={{color:'red',marginBottom:'10px'}}>{t("requiredActions")}</Title>
      <Label style={{color:'red'}}>{t("uploadPDF")}:</Label>

        <FieldGroup>
           <input
             type="file"
             accept="application/pdf"
             multiple
             onChange={(e) => handleFileChange(e, true)}
             ref={filesInputRef}
           />
        </FieldGroup>

        {/* <FileListContainer>
          {form.files.length === 0 && <p>{t('noFilesUploaded')}</p>}
          {form.files.map((file, index) => (
            <FileCard key={index}>
              <FileInfo>
                <span>{file.name}</span>
              </FileInfo>
              <FileActions>
                <a
                  href={URL.createObjectURL(file)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    e.stopPropagation();
                    openPreview(URL.createObjectURL(file));
                  }}
                  title={t('preview')}
                >
                  <FiFileText /> 
             
                </a>
                <a
                  href={URL.createObjectURL(file)}
                  download={file.name}
                  onClick={(e) => e.stopPropagation()}
                  title={t('download')}
                >
                  <FiDownload /> 
             
                </a>
                <button
                  className="delete"
                  type="button"
                  onClick={() => handleDeleteNewGalleryPhoto(index)}
                  title={t('delete')}
                >
                  <FiTrash2 /> 
               
                </button>
              </FileActions>
            </FileCard>
         ))}
        </FileListContainer> */}

  <FileListContainer>
            {form.existingFiles.length > 0 && (
              <>
                <h3>{t('existingUploadedFiles')}</h3>
                {form.existingFiles.map((fileUrl, index) => {
                  // Extract filename from URL for display
                  const fileName = fileUrl.split('/').pop();
                  return (
                    <FileCard key={`existing-${index}`}>
                      <FileInfo>
                        <span>{fileName}</span>
                      </FileInfo>
                      <FileActions>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.stopPropagation();
                            openPreview(fileUrl);
                          }}
                          title={t('preview')}
                        >
                          <FiFileText />
                        </a>
                        <a
                          href={fileUrl}
                          download={fileName}
                          onClick={(e) => e.stopPropagation()}
                          title={t('download')}
                        >
                          <FiDownload />
                        </a>
                      </FileActions>
                    </FileCard>
                  );
                })}
              </>
            )}
          </FileListContainer>

          {/* New files selected */}
          <FileListContainer>
            {form.files.length === 0 && <p>{t('noFilesUploaded')}</p>}
            {form.files.map((file, index) => (
              <FileCard key={index}>
                <FileInfo>
                  <span>{file.name}</span>
                </FileInfo>
                <FileActions>
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.stopPropagation();
                      openPreview(URL.createObjectURL(file));
                    }}
                    title={t('preview')}
                  >
                    <FiFileText />
                  </a>
                  <a
                    href={URL.createObjectURL(file)}
                    download={file.name}
                    onClick={(e) => e.stopPropagation()}
                    title={t('download')}
                  >
                    <FiDownload />
                  </a>
                  <button
                    className="delete"
                    type="button"
                    onClick={() => handleDeleteNewGalleryPhoto(index)}
                    title={t('delete')}
                  >
                    <FiTrash2 />
                  </button>
                </FileActions>
              </FileCard>
            ))}
          </FileListContainer>



      <UpdateButton type="submit">{t("Upload")}</UpdateButton>
    </form>


      {/* {uploadSuccess && (
        <SuccessMessage>
          {t("The admin will review your request.")}
        </SuccessMessage>
      )} */}

      {(uploadSuccess && (form.existingFiles.length > 0 || form.files.length > 0)) && (
          <SuccessMessage>
            {t("The admin will review your request.")}
          </SuccessMessage>
        )}

      {/* <ModalOverlay visible={modalVisible} onClick={closePreview}>
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <CloseButton onClick={closePreview}></CloseButton>
          {pdfPreviewUrl && (
            <PdfIframe
              src={pdfPreviewUrl}
              title="PDF Preview"
              allow="fullscreen"
            />
          )}
        </ModalContent>
      </ModalOverlay> */}

      </MainBox>
    </Container>
  );
};

export default ProfileMenuPreApprovedProvider;

